export enum EPitchSpecialization {
  equityPitch = "EquityPitch",
  fundPitch = "FundPitch",
  tokenPitch = "TokenPitch",
  convertibleNote = "ConvertibleNote"
}
